// DS: B0
import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import Add from '@wix/da-ds/pkg/Icons/24x24/Add';
import { useSubmitMenuItem } from '../../../hooks/useSubmitMenuItem';
import { submitButtonMenuItem } from '../../../constants';
const SubmitButton = ({ id , className  })=>{
    const { t  } = useTranslation();
    const { href , biData , onClick: submitOnClick  } = useSubmitMenuItem(submitButtonMenuItem);
    return /*#__PURE__*/ React.createElement(BrandedButton, {
        id: id,
        size: "medium",
        variant: "brand-green",
        icon: Add,
        className: className,
        href: href,
        onClick: submitOnClick,
        biData: biData
    }, t('siteHeader.submit'));
};
SubmitButton.displayName = 'SubmitButton';
export default SubmitButton;
